const Buttons = ({ className, BUY, url, PDP }) => {
  return `
<div class="${className.DETAILS.BUTTONS.WRAP}">
    <a class="${
      className.DETAILS.BUTTONS.ADD_TO_CART
    }" id="qvh24-buy-button">${BUY}</a>
    <a class="${
      className.DETAILS.BUTTONS.GO_TO_PRODUCTPAGE
    }" href="${url}">${PDP}</a>
</div>
  `;
};

export default Buttons;



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/components/quickview/components/Buttons/buttons.js
 **/